import React from "react";
import Sites from "../../constants/Sites";
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  RedditShareButton,
  EmailIcon,
  FacebookIcon,
  RedditIcon,
  XIcon,
  PinterestShareButton,
  PinterestIcon,
} from "react-share";
import styles from "../../../app/(postPageLayouts)/[...post]/Post/Post.module.css";
import "../../../app/(postPageLayouts)/[...post]/Post/Post.css";

const SocialShareButtons = ({ pageUrl, siteId, socialImage }) => (
  <div className={styles["socialshare"]}>
    <React.Fragment>
      <FacebookShareButton url={pageUrl}>
        <FacebookIcon size={32} round={true} />
      </FacebookShareButton>
      <TwitterShareButton url={pageUrl}>
        <XIcon size={32} round={true} />
      </TwitterShareButton>
      {(siteId === Sites.THE_LINE_UP ||
        siteId === Sites.THEPORTALIST ||
        siteId === Sites.EARLYBIRDBOOKS ||
        siteId === Sites.ALOVESOTRUE) && (
        <PinterestShareButton url={pageUrl} media={socialImage}>
          <PinterestIcon size={32} round={true} />
        </PinterestShareButton>
      )}
      <EmailShareButton url={pageUrl}>
        <EmailIcon size={32} round={true} />
      </EmailShareButton>
      {(siteId === Sites.THE_LINE_UP || siteId === Sites.THEPORTALIST) && (
        <RedditShareButton url={pageUrl}>
          <RedditIcon size={32} round={true} />
        </RedditShareButton>
      )}
    </React.Fragment>
  </div>
);

export default SocialShareButtons;
